import { uploadFile } from "@/api/file";

export default {
  async handleFileUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await uploadFile(formData);
      if (res.data.status === 200) {
        this.form.imagesUrls.push(res.data.url);
      } else {
        this.$message.error(res.data.message || "업로드 실패");
      }
    } catch (err) {
      this.$message.error("이미지 업로드에 실패했습니다.");
    }
    this.$refs.fileInput.value = "";
  },
  removeImage(index) {
    this.form.imagesUrls.splice(index, 1);
  },
};
